<template>
    <div class="ce-wrapper">
        <modal-x :show="showPickups" @onclose="showPickups = false">
            <h3 class="ce-pickup-title">{{ lang.contact.selectPickupLocation }}</h3>
            <paged-contact-core :userId="userId" hide-add-new="true" v-on:onselect="onPickupSelected" v-if="showPickups"
                :cat-id="pickupCatId" :apiClient="apiClient"></paged-contact-core>
        </modal-x>
        <modal-x :show="showCities" @onclose="showCities = false" :content-style="{ maxWidth: '800px' }">
            <category-tree :show-node="false" :expand-child="true" :cat-node="cityNode"
                v-on:catSelected="citySelecting"></category-tree>
        </modal-x>
        <modal-x :show="showPhoneDistrict" @onclose="showPhoneDistrict = false" :content-style="{ maxWidth: '800px' }">
            <category-tree :show-node="false" :expand-child="true" :cat-node="phoneDistrictNode"
                v-on:catSelected="phoneDistrictSelecting"></category-tree>
        </modal-x>
        <modal-x :show="showPickupCats" @onclose="showPickupCats = false" :content-style="{ maxWidth: '800px' }">
            <category-tree :show-node="false" :expand-child="true" :cat-node="pickupLocationNode"
                v-on:catSelected="pickupLocationSelecting"></category-tree>
        </modal-x>
        <div>
            <div class="ce-form-panel">
                <div class="ce-section-title">
                    <h3>{{ lang.contact.newContact }}</h3>
                </div>
                <input type="hidden" />
                <div>
                    <input v-model="newContact.title" type="text" :placeholder="lang.contact.addressRemark"
                        class="ce-input" />
                </div>
                <div>
                    <input v-model="newContact.name" type="text" :placeholder="lang.contact.contactName"
                        class="ce-input" />
                </div>
                <div>
                    <div class="ce-phone-group">
                        <span @click="selectPhoneArea" data-selected="" class="ce-phone-area-btn">
                            <span class="glyphicon glyphicon-triangle-bottom"></span> {{ phoneArea }}
                        </span>
                        <input v-model="newContact.phone" type="text" class="ce-phone-input" :placeholder="lang.common.phone">
                    </div>
                </div>

                <div v-if="skipAddress !== true">
                    <div class="ce-address-wrapper">

                        <div class="ce-tab-nav">
                            <span class="ce-tab-btn" :class="{ 'ce-tab-btn-active': addressTab === 0 }"
                                @click="addressTab = 0">{{
                                    lang.contact.deliveryAddress
                                }}</span>
                            <span class="ce-tab-btn"
                                :class="{ 'ce-tab-btn-active': addressTab === 1, hidden: apiClient.pickupEnabled !== true }"
                                @click="addressTab = 1">{{
                                    lang.common.pickup
                                }}</span>
                        </div>

                        <div class="ce-tab-content">
                            <div :class="{ hidden: addressTab !== 0 }">
                                <div>
                                    <select v-if="pickupEntry === true" v-on:change="contactTypeChange"
                                        class="ce-select" v-model="newContact.contactType">
                                        <option value="">Please select type</option>
                                        <option value="0">Delivery Address</option>
                                        <option value="1">Pick up location</option>
                                    </select>

                                    <span @click="selectCity" data-selected="" class="ce-selector-btn">
                                        <span class="glyphicon glyphicon-triangle-bottom"></span> {{ city }}
                                    </span>

                                </div>
                                <div>
                                    <textarea v-model="newContact.address" class="ce-textarea"
                                        :placeholder="lang.contact.newAddress"></textarea>
                                </div>
                            </div>
                            <div :class="{ hidden: addressTab !== 1 }">
                                <div>
                                    <span @click="selectPickup" class="ce-selector-btn">
                                        <span class="glyphicon glyphicon-triangle-bottom"></span> {{
                                            lang.common.pickupLocation
                                        }}
                                    </span>
                                </div>
                                <div>
                                    <div class="ce-pickup-display">
                                        <div v-if="pickupContact !== null">
                                            <div>
                                                <span class="ce-pickup-badge">{{ lang.common.pickup }}</span>
                                                <div class="ce-pickup-title-text">
                                                    {{ pickupContact.id }}:{{ pickupContact.title }}
                                                </div>
                                            </div>
                                            <div class="ce-pickup-detail">
                                                {{ pickupContact.name }}:{{ pickupContact.phone }}
                                                <div>
                                                    {{ pickupContact.address }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div>
                    <div class="ce-action-bar">
                        <span @click="addContact" class="ce-add-btn">{{ lang.common.add }}</span>
                        <div class="ce-error-msg">
                            {{ msg }}
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>
<script>
import pagedLoading from './base/PagedLoading.vue';
import modalX from './base/ModalX1.vue';
import CategoryTree from './CategoryTree.vue';
import language from '../api/lang';

export default {
    components: {
        CategoryTree: CategoryTree,
        pagedLoading: pagedLoading,
        modalX: modalX,
        pagedContactCore: () => import('./PagedContactCore.vue')
    },
    props: {
        "apiClient": { type: String, default: null },
        "userId": { type: String, default: null },
        "pickupEntry": { type: Boolean, default: false },
        "skipAddress": { type: Boolean, default: false }
    },
    data: function () {
        return {
            items: [],
            paging: { page: 1, pageSize: 1, count: 1 },
            loadingImg: false,
            msg: null,
            phoneArea: language.common.phoneAreaNo,
            city: language.common.city,
            newContact: {
                phoneAreaNo: null,
                cityNo: 0,
                title: null,
                name: null,
                phone: null,
                address: "",
                pickContactId: 0,
                contactType: this.pickupEntry === true ? 1 : 0
            },
            addressTab: 0, //0 for direct address, 1 for pickup
            showPickups: false,
            pickupCatId: null,
            pickupContact: null,
            showCities: false,
            cityNode: null,
            showPhoneDistrict: false,
            phoneDistrictNode: null,
            showPickupCats: false,
            pickupLocationNode: null
        };
    },
    computed: {
        lang: function () {
            return language;
        }
    },
    methods: {
        resetCity() {
            this.city = language.common.city;
            this.newContact.cityNo = 0
        },
        contactTypeChange() {
            this.resetCity();
        },
        pickupLocationSelecting(ret) {
            this.pickupCatId = ret.child.catId;
            this.showPickupCats = false;
            this.showPickups = true;
        },
        onPickupSelected: function (pickupContact) {
            this.pickupContact = pickupContact;
            this.newContact.pickContactId = pickupContact.id;
            this.showPickups = false;
        },
        selectPickup: function () {
            this.apiClient.getPickupPrms(this.userId).done((ret) => {
                this.pickupLocationNode = ret;
                this.showPickupCats = true;
            });
        },
        selectPhoneArea: function () {
            this.apiClient.getPhoneDistrictPrms().done((ret) => {
                this.showPhoneDistrict = true;
                this.phoneDistrictNode = ret;
            });
        },
        phoneDistrictSelecting(ret) {
            this.phoneArea = ret.parent.name + "/" + ret.child.name;
            this.newContact.phoneAreaNo = ret.child.catId;
            this.showPhoneDistrict = false;
        },
        selectCity: function () {
            if (this.newContact.contactType == 0) {
                this.apiClient.getCityPrms().done((ret) => {
                    this.showCities = true;
                    this.cityNode = ret;
                });
            } else {
                this.apiClient.getPickupPrms(this.userId).done((ret) => {
                    this.showCities = true;
                    this.cityNode = ret;
                });
            }
        },
        citySelecting(ret) {
            console.log('city selecting', ret);
            this.city = ret.parent.name + "/" + ret.child.name;
            this.newContact.cityNo = ret.child.catId;
            this.showCities = false;
        },
        addContact: function () {
            this.msg = "";

            this.newContact.contactType = this.addressTab;
            //validate data
            console.log("new contact:", this.newContact);

            var hasTitle = this.newContact.title !== null;
            var hasName = this.newContact.name !== null;
            var hasPhone = this.newContact.phone !== null;
            var hasPhoneArea = this.newContact.phoneAreaNo !== null;

            if (!(hasName && hasPhone && hasPhoneArea && hasTitle)) {
                this.msg = this.lang.contact.wrongContactValue;
                return;
            }

            if (this.skipAddress !== true) {
                var contactType = this.newContact.contactType;
                if (contactType === 0) {
                    //direct user address
                    var addressNotEmpty = this.newContact.address !== null;
                    var hasCity = this.newContact.cityNo !== 0;

                    var isValid = addressNotEmpty && hasCity;
                    if (!isValid) {
                        this.msg = this.lang.contact.wrongAddressValue;
                        return;
                    }

                } else {
                    //pickup
                    var hasPickup = this.newContact.pickContactId !== 0;
                    if (!hasPickup) {
                        this.msg = this.lang.contact.wrongPickupValue;
                        return;
                    }
                }
            }
            //end validation

            this.apiClient.addContactPrms(this.newContact)
                .done((ret) => {
                    this.$emit('oncreate', ret);
                });
        }
    }
    ,
    created: function () {
        //this.loadItems();
        //this.apiClient.onLoginApi.on(this.loadItems);
    },
    //destroyed: function () {
    //    this.apiClient.onLoginApi.remove(this.loadItems);
    //}
}
</script>